import { useIntl } from "react-intl";
import SwapVertical from "src/design-system/icons/SwapVertical.svg?react";
import { sendAnalyticsInteractionEvent } from "src/analytics/sendAnalyticsEvent";
import { Button } from "react-aria-components";
import { tw } from "src/design-system/tw";
import Pin from "src/design-system/icons/Pin.svg?react";
import messages from "./SearchBox.messages";

type Props = {
  origin?: string;
  destination?: string;
  onSwitchClick: () => void;
  onOriginClick: () => void;
  onDestinationClick: () => void;
};

export function SearchBox(props: Props) {
  const intl = useIntl();

  return (
    <div className="bg-neutral-300 p-2">
      <div className="relative">
        <div
          className={tw(
            "relative m-0 w-full overflow-hidden border border-border",
            props.origin && "rounded-t-sm border-b-0",
          )}
        >
          <span className="pointer-events-none absolute top-1/2 left-4.5 h-2 w-2 -translate-y-1/2 rounded-full border border-icon-secondary" />
          <input
            className={tw(
              "block h-12 w-full rounded-sm border-none bg-surface pt-3.5 pr-2 pb-3.5 pl-10 text-transport-grey-700",
              "focus:outline-none active:bg-neutral-700",
            )}
            onClick={(event) => {
              props.onOriginClick();
              sendAnalyticsInteractionEvent({
                category: "SearchBox",
                action: "Click:Origin",
              });
              event.preventDefault();
            }}
            aria-label={intl.formatMessage(messages.origin)}
            id="origin"
            value={props.origin ?? ""}
            readOnly
            // Allow Hotjar to show destinations in input
            data-hj-allow="data-hj-allow"
          />
        </div>
        <Button
          className={tw(
            "absolute top-1/2 right-4 z-10 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full border border-border bg-surface",
            "data-focus-visible:outline-3 data-focus-visible:-outline-offset-2 data-focus-visible:outline-fill-brand data-pressed:bg-neutral-700",
          )}
          onClick={(event) => {
            props.onSwitchClick();
            sendAnalyticsInteractionEvent({
              category: "SearchBox",
              action: "Click:Switch",
            });
            event.preventDefault();
          }}
          aria-label={intl.formatMessage(messages.switch)}
        >
          <SwapVertical
            title="switch"
            className="h-5 w-5 text-icon-secondary"
          />
        </Button>
        <div className="relative m-0 w-full overflow-hidden rounded-b-sm border border-border">
          <span className="absolute top-1/2 left-3 -translate-y-1/2">
            <Pin title="pin" className="h-4.5 w-4.5 text-icon-secondary" />
          </span>
          <input
            className={tw(
              "block h-12 w-full rounded-sm border-none bg-surface pt-3.5 pr-2 pb-3.5 pl-10 text-transport-grey-700",
              "focus:outline-none active:bg-neutral-700",
            )}
            onClick={(event) => {
              props.onDestinationClick();
              sendAnalyticsInteractionEvent({
                category: "SearchBox",
                action: "Click:Destination",
              });
              event.preventDefault();
            }}
            aria-label={intl.formatMessage(messages.destination)}
            id="destination"
            value={props.destination ?? ""}
            readOnly
          />
        </div>
      </div>
    </div>
  );
}
